import type { ThemeName } from 'atoms/themeAtom';

// ショートカットの表示文言・キー割当の SSOT（router 非依存の純データ）。
// チートシート表示（ShortcutCheatsheet）と実挙動（useGlobalShortcuts）の双方が参照する。
export interface ShortcutDef {
    id: string;
    keys: string[]; // 表示用のキー表記
    label: string;
}

export const SHORTCUTS: ShortcutDef[] = [
    { id: 'palette', keys: ['⌘K', 'Ctrl+K'], label: 'コマンドパレットを開閉' },
    { id: 'cheatsheet', keys: ['?'], label: 'このショートカット一覧を表示' },
    { id: 'sidenav', keys: ['B'], label: 'サイドナビを開閉' },
    { id: 'theme', keys: ['T'], label: 'テーマを切替' },
    { id: 'prev', keys: ['['], label: '前のステップへ（ツール内）' },
    { id: 'next', keys: [']'], label: '次のステップへ（ツール内）' },
    { id: 'close', keys: ['Esc'], label: 'ダイアログ／ツアーを閉じる' },
];

// テーマ巡回の順序（UserMenu / コマンドパレットの選択肢と同じ4種）。
const THEME_ORDER: ThemeName[] = ['gray', 'white', 'black', 'red'];
export const nextThemeName = (current: ThemeName): ThemeName =>
    THEME_ORDER[(THEME_ORDER.indexOf(current) + 1) % THEME_ORDER.length];

// 単キーショートカットを無効化すべき入力系要素か。テキスト入力 / textarea / select /
// contenteditable、および MUI Select の combobox/listbox（type-ahead と衝突する）を対象にする。
export const isEditableTarget = (target: EventTarget | null): boolean => {
    const el = target as HTMLElement | null;
    if (!el || typeof el.tagName !== 'string') return false;
    if (el.isContentEditable) return true;
    const tag = el.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (
        typeof el.closest === 'function' &&
        el.closest('[role="combobox"], [role="listbox"], [contenteditable="true"]')
    ) {
        return true;
    }
    return false;
};
